export default __webpack_public_path__ + "static/media/floor-demo.0a62d504.png";